import { withInstall } from '../helpers';

import Cascader from './src/QCascader.vue';

export const QCascader = withInstall(Cascader);

export type { QCascaderProps, QCascaderInstance } from './src/types';
